module.exports = __webpack_public_path__ + "static/img/cnc2.6cac126.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/cnc2.jpg
// module id = vN+Y
// module chunks = 2